/** Persistência do tour guiado (localStorage). */
export const TOUR_STORAGE_KEY = 'facedoor_tour_status';

export type TourStatus = 'completed' | 'skipped';

export interface TourStep {
  id: string;
  /** Seletor `[data-tour="…"]`. Omitir = passo central (sem highlight). */
  target?: string;
  title: string;
  body: string;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'center';
}

export const TOUR_STEPS: TourStep[] = [
  {
    id: 'welcome',
    title: 'Bem-vindo ao portal',
    body: 'Este tour rápido mostra como navegar pelo sistema. Leva menos de um minuto — você pode pular ou sair a qualquer momento.',
    placement: 'center',
  },
  {
    id: 'logo',
    target: 'header-logo',
    title: 'Página inicial',
    body: 'Clique no nome ou logo do sistema para voltar à home e ver todos os módulos disponíveis.',
    placement: 'bottom',
  },
  {
    id: 'search',
    target: 'home-search',
    title: 'Buscar módulos',
    body: 'Digite aqui para filtrar os atalhos pelo nome ou pela descrição, sem precisar rolar a página.',
    placement: 'bottom',
  },
  {
    id: 'modules',
    target: 'home-modulos',
    title: 'Módulos por área',
    body: 'Os atalhos ficam agrupados em Pessoas & Cadastros, Controle de Acesso e Sistema & Suporte. Só aparecem os módulos que seu perfil pode acessar.',
    placement: 'top',
  },
  {
    id: 'notifications',
    target: 'header-notificacoes',
    title: 'Notificações',
    body: 'Acompanhe avisos e mensagens internas enviadas pelo sistema ou por outros usuários.',
    placement: 'bottom',
  },
  {
    id: 'help',
    target: 'header-ajuda',
    title: 'Ajuda e FAQ',
    body: 'Consulte perguntas frequentes ou abra um chamado de suporte quando precisar de ajuda.',
    placement: 'bottom',
  },
  {
    id: 'theme',
    target: 'header-tema',
    title: 'Modo claro / escuro',
    body: 'Alterne a aparência do portal. Sua preferência fica salva neste navegador.',
    placement: 'bottom',
  },
  {
    id: 'profile',
    target: 'header-perfil',
    title: 'Seu perfil',
    body: 'Atualize seus dados, foto e senha. O avatar no canto superior direito leva ao seu perfil.',
    placement: 'bottom',
  },
  {
    id: 'done',
    title: 'Pronto para começar!',
    body: 'Explore os módulos conforme suas permissões. Para refazer este tour, acesse Ajuda → Tour guiado.',
    placement: 'center',
  },
];

export function getTourStatus(): TourStatus | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = localStorage.getItem(TOUR_STORAGE_KEY);
    return v === 'completed' || v === 'skipped' ? v : null;
  } catch {
    return null;
  }
}

export function shouldOfferTour(): boolean {
  return getTourStatus() === null;
}

export function persistTourStatus(status: TourStatus): void {
  try {
    localStorage.setItem(TOUR_STORAGE_KEY, status);
  } catch {
    /* ignore */
  }
}

export function resetTourStatus(): void {
  try {
    localStorage.removeItem(TOUR_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
